import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";

import Dashboard from "@/pages/Dashboard.vue";
import Show from "@/pages/Show.vue";
import User from "@/pages/User.vue";
import Alarm from "@/pages/Alarm.vue";
import Typography from "@/pages/Typography.vue";
import PlantInfo from "@/pages/PlantInfo.vue"
import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Notifications from "@/pages/Notifications.vue";
import UpgradeToPRO from "@/pages/UpgradeToPRO.vue";
import Login from "@/pages/Login.vue";
import Analysis from "@/pages/Analysis.vue"
import axios from 'axios';

//js
import ESjs from '../assets/js/main.js'
import Vue from "vue";

//css
import '../assets/css/main.css' //es樣式

Vue.use(ESjs)

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/show",
    children: [
      {
        path: "show",
        name: "展示頁",
        component: Show
      },
      {
        path: "dashboard",
        name: "資訊總覽",
        component: Dashboard
      },
      {
        path: "user",
        name: "使用者設定",
        component: User
      },
      {
        path: "plant_info",
        name: "案場資訊",
        component: PlantInfo
      },
      {
        path: "alarm",
        name: "警報",
        component: Alarm
      },
      {
        path: "analysis",
        name: "分析",
        component: Analysis
      },
      {
        path: "icons",
        name: "Icons",
        component: Icons
      },
      {
        path: "maps",
        name: "Maps",
        meta: {
          hideFooter: true
        },
        component: Maps
      },
      {
        path: "notifications",
        name: "Notifications",
        component: Notifications
      },
      {
        path: "upgrade",
        name: "Upgrade to PRO",
        component: UpgradeToPRO
      }
    ]
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/logout",
    component: {
      render(c) {
          axios.get("/logout").
          finally(
            function(){
              window.location.href = "/login"
            }
          )
      }
  }
  }
];

export default routes;
